<template>
    <div class="sellpanel">
        <span
            v-for="item in innerData"
            :key="item.sellPointContentId"
            v-dragging="needDrag ? {item: item, list: innerData, group: 'item'} : {}"
            class="tag-warpper"
        >
            <el-tooltip
                :content="item.sellPointTypeName"
                :open-delay="300"
                placement="top"
            >
                <el-tag
                    size="medium"
                    :closable="editable"
                    type="primary"
                    @close="removeTag(item.sellPointContentId)"
                >{{ `${item.sellPointContentName}` }}</el-tag>
            </el-tooltip>
        </span>
        <span v-if="!innerData.length && !editable">无</span>
        <template v-if="editable">
            <el-button
                v-if="!sellSelect"
                class="add-btn"
                size="mini"
                :disabled="disabled"
                icon="el-icon-plus"
                @click="show"
            />
            <el-button
                v-else
                class="sell-select-button"
                size="mini"
            >
                <div>
                    <el-select
                        ref="selectNode"
                        v-model="selectedSell"
                        filterable
                        remote
                        :remote-method="fetchSellPoints"
                        :loading="loading"
                        placeholder="搜索卖点内容"
                        size="small"
                        @change="addSellPoint"
                        @blur="hide()"
                    >
                        <el-option
                            v-for="item in searchResult"
                            :key="item.sellPointContentId"
                            :label="item.sellPointContentName"
                            :value="item"
                            :disabled="valueList.indexOf('' + item.sellPointContentId) !== -1"
                        />
                    </el-select>
                </div>
            </el-button>
        </template>
    </div>
</template>

<script>
export default {
    name: 'SellPanel',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        editable: {
            type: Boolean,
            default: false,
        },
        isShowAdd: {
            type: Boolean,
            default: false,
        },
        needDrag: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        skuBaseId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            innerData: this.value || [],
            sellSelect: false, // +号的开关
            selectedSell: null,
            searchResult: [],
            keyword: '', // 搜索关键词
            loading: false,
        };
    },
    computed: {
        valueList() {
            return this.innerData.map(
                (v) => v.sellPointContentId,
            );
        },
        handleInnerData() {
            return this.innerData.map((item, idx) => ({
                ...item,
                sequence: idx,
                skuBaseId: this.skuBaseId,
            }));
        },
    },
    watch: {
        value(newVal) {
            this.innerData = newVal;
        },
    },
    created() {
    },
    methods: {
        // 搜索
        show() {
            this.selectedSell = null;
            this.sellSelect = true;
            this.$nextTick(() => {
                this.$refs.selectNode.focus();
            });
        },
        hide(immediately = false) {
            setTimeout(() => {
                this.sellSelect = false;
                // 不清空好像效果好一点
                this.searchResult = [];
            }, immediately ? 0 : 500);
        },
        addSellPoint(tag) {
            if (this.valueList.indexOf(tag.sellPointContentId) !== -1) {
                this.hide(true);
                return;
            }
            this.innerData.push(tag);
            this.hide(true);
            this.$emit('input', this.handleInnerData);
        },
        removeTag(id) {
            const sellIndex = this.valueList.indexOf(id);
            if (sellIndex === -1) {
                return;
            }
            const list = [...this.innerData];
            list.splice(sellIndex, 1);
            this.innerData = list;
            this.$emit('input', this.handleInnerData);
        },
        fetchSellPoints(keyword) {
            this.keyword = keyword;
            if (!keyword) {
                this.searchResult = [];
                return;
            }
            this.loading = true;

            this.$post(
                `${window.location.origin}/api/vss/shepherd/product/searchSellPointAllList`,
                {
                    sellPointContentName: keyword,
                    sellPointTypeId: -1,
                    paging: {
                        limit: 10,
                        offset: 0,
                    },
                },
            ).then((res) => {
                if (keyword !== this.keyword) {
                    return;
                }
                console.log('res', res);
                const dataList = res.resultList.filter((v) => (
                    v
                        && v.sellPointContentId
                        && this.valueList.indexOf(`${v.sellPointContentId}`) === -1
                ));
                console.log('dataList', dataList);
                this.loading = false;
                this.searchResult = dataList;
            });
        },
    },
};
</script>
<style scoped lang="scss">
.sellpanel {
    min-height: 40px;
    .tag-warpper {
        cursor: pointer;
    }
    .add-btn {
        min-width: 30px;
    }
    .sell-select-button {
        transition: none;
        padding: 0;
        border: none;
    }
    .el-tag {
        margin: 3px;
    }
}
</style>
